export const DEFAULT_REVIEW_RATING = 5
export const DEFAULT_REVIEW_COUNT = 723
export const MIN_VISIBLE_REVIEW_COUNT = 5
export const MAX_VISIBLE_DOTS = 5
export const INITIAL_VISIBLE_REVIEW_COUNT = 4

// Pin locale + timezone for any Intl/toLocale* call rendered during SSR
// so server (UTC, host locale) and client (user's TZ/locale) agree.
export const DEFAULT_LOCALE = 'en-US'
export const DEFAULT_TIME_ZONE = 'UTC'
